// /calls DataGrid 컬럼 정의.
// flex 전면 제거 → width + minWidth 고정. 넘치는 컬럼은 그리드 내부 가로 스크롤로 처리.

import type { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { StatusChip } from "components/list";
import { ICall } from "../interfaces";
import { inOutMeta, participationMeta, resolveStatusMeta } from "./callsStatus";

export const callsColumns: GridColDef<ICall>[] = [
  {
    field: "id",
    headerName: "ID",
    type: "number",
    width: 84,
    minWidth: 72,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "in_out",
    headerName: "IN/OUT",
    type: "string",
    width: 96,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(inOutMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "centerId",
    headerName: "시설ID",
    type: "string",
    width: 90,
    minWidth: 80,
    align: "center",
    headerAlign: "center",
  },
  { field: "c_mamanger", headerName: "시설 관계자", type: "string", width: 120, minWidth: 100 },
  { field: "m_ph", headerName: "전화번호", type: "string", width: 130, minWidth: 110 },
  {
    field: "m_email",
    headerName: "이메일",
    type: "string",
    width: 370,
    minWidth: 300,
  },
  {
    field: "participation",
    headerName: "상태",
    type: "string",
    width: 96,
    minWidth: 88,
    align: "center",
    headerAlign: "center",
    renderCell: (params: GridRenderCellParams) => {
      const meta = resolveStatusMeta(participationMeta, params.value);
      return <StatusChip label={meta.label} color={meta.color} />;
    },
  },
  {
    field: "userId",
    headerName: "콜요원ID",
    type: "string",
    width: 90,
    minWidth: 80,
    align: "center",
    headerAlign: "center",
  },
  { field: "date", headerName: "연락날짜", type: "string", width: 116, minWidth: 108, align: "center", headerAlign: "center" },
  { field: "time", headerName: "연락시간", type: "string", width: 108, minWidth: 100, align: "center", headerAlign: "center" },
  { field: "center_etc", headerName: "시설 메모", type: "string", width: 240, minWidth: 160, sortable: false },
  { field: "agent_etc", headerName: "현장요원 메모", type: "string", width: 240, minWidth: 160, sortable: false },
  { field: "updatedAt", headerName: "수정일", type: "string", width: 236, minWidth: 190, align: "center", headerAlign: "center" },
];
